import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const ApartamentosPage = lazy(() => import('../pages/apartamentos/page'));
const ApartamentoPage = lazy(() => import('../pages/apartamento/page'));
const ExperienciasPage = lazy(() => import('../pages/experiencias/page'));
const ContactosPage = lazy(() => import('../pages/contactos/page'));
const FAQPage = lazy(() => import('../pages/faq/page'));
const PrivacidadePage = lazy(() => import('../pages/privacidade/page'));
const TermosPage = lazy(() => import('../pages/termos/page'));
const PoliticaCancelamentoPage = lazy(() => import('../pages/politica-cancelamento/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/apartamentos',
    element: <ApartamentosPage />,
  },
  {
    path: '/apartamento/:id',
    element: <ApartamentoPage />,
  },
  {
    path: '/experiencias',
    element: <ExperienciasPage />,
  },
  {
    path: '/contactos',
    element: <ContactosPage />,
  },
  {
    path: '/faq',
    element: <FAQPage />,
  },
  {
    path: '/privacidade',
    element: <PrivacidadePage />,
  },
  {
    path: '/termos',
    element: <TermosPage />,
  },
  {
    path: '/politica-cancelamento',
    element: <PoliticaCancelamentoPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;